import { shouldShowBizChatInReadingPane } from '../selectors/shouldShowBizChatInReadingPane';
import { setShowBizChatInReadingPaneMutator } from '../mutators/setShowBizChatInReadingPaneMutator';
import { onCopilotChatDrawerLayoutChange } from '../actions/onCopilotChatDrawerLayoutChange';

export const closeBizChatInReadingPane = (targetWindow: Window): void => {
    if (shouldShowBizChatInReadingPane(targetWindow)) {
        setShowBizChatInReadingPaneMutator(targetWindow, false);
        onCopilotChatDrawerLayoutChange();
    }
};
